import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = (options = { threshold: 0.1 }) => {
  const ref = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          if (currentRef) {
            observer.unobserve(currentRef);
          }
        }
      });
    }, options);

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options, ref]);

  return [ref, isIntersecting];
};

export default useIntersectionObserver;
